
<template>
  <div class="mt-24 grid grid-cols-1 place-items-center">
    <p class="middle-text">{{ tips }}</p>
    <van-button
      class="m-2 w-16"
      round
      type="success"
      v-if="showCheckin"
      @click="changeBookStatus('checkin')"
      >返回签到</van-button
    >
    <van-button
      class="m-2 w-16"
      round
      type="success"
      v-if="showFirstCheckin"
      @click="changeBookStatus('checkin')"
      >签到</van-button
    >
    <van-button
      class="m-2 w-16"
      round
      type="primary"
      v-if="showGoHome"
      @click="goHome()"
      >返回首页</van-button
    >
    <van-button
      class="m-2 w-16"
      round
      type="primary"
      v-if="showLeave"
      @click="changeBookStatus('leave')"
      >临时离开</van-button
    >
    <van-button
      class="m-2 w-16"
      round
      type="warning"
      v-if="showLeave"
      @click="changeBookStatus('checkout')"
      >完全离开</van-button
    >
  </div>
</template>

<script>
import { toRefs, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { Dialog } from "vant";
import {
  scanBook,
  getSysConfig,
  getCurrentUse,
  changeBook,
  changeSeat,
} from "@/service/home";
import Cookies from "js-cookie";
import qs from "qs";

export default {
  name: "scanBook",
  components: {},
  setup() {
    const user = JSON.parse(Cookies.get("user"));
    const seat = Cookies.get("seat");
    const schoolConfig = JSON.parse(Cookies.get("school"));
    const router = useRouter();
    const state = reactive({
      showLeave: false,
      showCheckin: false,
      showFirstCheckin: false,
      showGoHome: false,
      tips: "正在扫码预约",
      currentSeatBooking: {},
    });
    onMounted(async () => {
      const sysconfig = await getSysConfig();
      state.currentSeatBooking = await getCurrentUse({
        user: user.userid,
      });
      const data = await scanBook({
        seat: seat,
        access_token: user.access_token,
        userid: user.userid,
        operateChannel: 3,
      });
      if ([0, 1, 2, 5, 8].includes(data.data.status)) {
        Dialog.alert({
          message: data.data.msg,
        }).then(() => {
          goHome();
        });
      }
      if (data.data.status === 3) {
        if (schoolConfig.showLeave) {
          state.showLeave = true;
          state.tips = "是否需要临时离开或签离座位？";
        } else {
          state.showLeave = false;
          state.showGoHome = true;
          state.tips = "您已经预约了该座位，请勿重复操作！";
        }
      }
      if (data.data.status === 4) {
        if (sysconfig.QR_CHANGE_SEAT == 0) {
          state.tips = data.data.msg;
          state.showGoHome = true;
        } else {
          Dialog.confirm({
            message: "您已预约了其它座位，是否需要换到这个座位？",
          }).then(() => {
            changeSeatNow();
          });
        }
      }
      if (data.data.status === 7) {
        if (schoolConfig.showCheckin) {
          state.showCheckin = true;
          state.tips = "请完成返回签到";
        } else {
          state.showCheckin = false;
          state.showGoHome = true;
          state.tips = "请完成返回签到";
        }
      }
      if (data.data.status === 6) {
        if (schoolConfig.showFirstCheckin) {
          state.showFirstCheckin = true;
          state.tips = "请完成签到";
        } else {
          state.showFirstCheckin = false;
          state.showGoHome = true;
          state.tips = "请完成签到";
        }
      }
    });
    const goHome = () => router.push("/index");
    const changeSeatNow = async () => {
      const data = await changeSeat({
        userid: user.userid,
        seat: seat,
        access_token:user.access_token,
        operateChannel:3
      });
      Dialog.alert({
        message: data.data.msg,
      }).then(() => {
        goHome();
      });
    };

    const changeBookStatus = async (method) => {
      try {
        let currentSeatBook = state.currentSeatBooking.filter(book=>book.isSingle==1)[0];
        let bookId = currentSeatBook && currentSeatBook.id;
        if (!bookId) {
          throw new Error("您当前没有预约信息");
        }
        const result = await changeBook(
          bookId,
          qs.stringify({
            id:bookId,
            _method: method,
            access_token: user.access_token,
            userid: user.userid,
            operateChannel: 3,
          })
        );
        if (result.status == 1) {
          Dialog.alert({
            title: "提示",
            allowHtml: true,
            message: result.msg,
          }).then(() => {
            goHome();
          });
        } else {
          throw new Error(result.msg);
        }
      } catch (error) {
        Dialog.alert({
          title: "提示",
          allowHtml: true,
          message: error.message,
        }).then(() => {
          goHome();
        });
      }
    };
    return {
      goHome,
      changeBookStatus,
      ...toRefs(state),
    };
  },
};
</script>

<style lang="less" scoped>
@import "../common/style/base";
</style>